import { EEecsRegistry } from 'types';

import { EGrexCountry } from '../types/grex.types';

export const GrexCountryMap = {
  [EGrexCountry.DENMARK]: {
    shortName: 'GREX DK',
    name: 'G-REX Denmark (Energinet)',
    registry: EEecsRegistry.GREX_DK,
  },
};
